define(['jquery'], function($){

	$.fn.dhtmlNumber = function(options) {

		var opts = $.extend({}, $.fn.dhtmlNumber.defaults, options);

		// hlavni cyklus
		return this.each(function() {
			var $t = $(this);

			if ($t.data('dhtmlNumberPluginUsed') == "true") {
				return true;
			}
			$t.data('dhtmlNumberPluginUsed', "true");

			$t.attr('autocomplete', 'off');
			$t.wrap('<span></span>');
			var $wrapper = $t.parents("span");
			$wrapper.addClass(opts.wrapperClass);
			var minValue 		=  $t.data("min") || opts.minValue;
			var maxValue 		=  $t.data("max") || opts.maxValue;
			var defaultValue 	=  ($t.val() || $t.data("default")) || opts.defaultValue;
			var step 			=  $t.data("step") || opts.step;

            $t.bind('change', function(e) {
                $t.trigger("dhtmlNumberChange", [{
                  obj: $t
                }]);
            });

			$t.val(defaultValue);
			$.fn.dhtmlNumber.appendControls($wrapper, minValue, maxValue, defaultValue);
			$.fn.dhtmlNumber.handleKeys($t, minValue, maxValue);
			$.fn.dhtmlNumber.handleControls($t, $wrapper, minValue, maxValue, step);
		});
	};

	$.fn.dhtmlNumber.appendControls = function(obj, mi, mx, defVal) {
		var str = new this.StringBuffer();
		str.append('<a href="#" class="glyphicon glyphicon-up plus" title="+">+</a>');
        if ( defVal == "0" ) {
            str.append('<a href="#" class="glyphicon glyphicon-down minus disabled" title="-">-</a>');
        } else {
            str.append('<a href="#" class="glyphicon glyphicon-down minus" title="-">-</a>');
        }
		obj.append(str.getString());
	};

	$.fn.dhtmlNumber.handleControls = function(obj, wrapper, mi, mx, st) {
        $("a.minus", wrapper).prependTo(wrapper);
		$("a.plus", wrapper).bind("click", function(e) {
			e.preventDefault();

			var val = parseFloat(obj.val());
			if(isNaN(val)) {
				val = st;
			}
			val += st;
			if (mx != null && val > mx) {
				val = mx;
			}
			val = $.fn.dhtmlNumber.roundByDecimals(val, st);
			obj.val(val);

            if ( obj.val() > 0 ) {
                $('a.minus', wrapper).removeClass('disabled');
            }

            obj.trigger("dhtmlNumberChange", [{
                obj: obj
            }]);
		});

		$("a.minus", wrapper).bind("click", function(e) {
			e.preventDefault();

            if ( obj.val() < 1 ) {
                return false;
            }

			var val = parseFloat(obj.val());
			if(isNaN(val)) {
				val = st;
			}
			val -= st;
			if (mi != null && val < mi) {
				val = mi;
			}
			val = $.fn.dhtmlNumber.roundByDecimals(val, st);
			obj.val(val);

            if ( obj.val() < 1 ) {
                $(this).addClass('disabled');
            } else {
                $(this).removeClass('disabled');
            }

            obj.trigger("dhtmlNumberChange", [{
                obj: obj
            }]);
		});

	};

	$.fn.dhtmlNumber.handleKeys = function(obj, mi, mx) {
		var value;
		obj.bind("keydown", function(e) {
			if (!isNaN($(this).val())){
				value = $(this).val();
			}
		});

		obj.bind("keyup", function(e) {
			var val = $(this).val();
			val = val.replace(",",".");
			$(this).val(val);
			if ((val !="-") && isNaN(val)) {
				obj.val(value);
			}

			if (val !="-" && val !="" && mx != null && val > mx) {
				obj.val(mx);
			}
			if (val !="-" && val !="" && mi != null && val < mi) {
				obj.val(mi);
			}
            //console.log(val);
            obj.trigger("dhtmlNumberChange", [{
                obj: obj
            }]);
		});
	};

	$.fn.dhtmlNumber.defaults = {
		minValue				:	null,
		maxValue				:	null,
		defaultValue			:	0,
		step					:	1,
		wrapperClass			:	""
	};

	/**
	 * objekt pro lepsi spravu stringu
	 */
	$.fn.dhtmlNumber.StringBuffer = function() {
		this.buffer = "";
		this.append = function(str) { this.buffer += str; return this; };
		this.getString = function() { return this.buffer; };
		this.reset = function() { this.buffer=""; };
	};
	/* zaokrouhlování */
	$.fn.dhtmlNumber.roundByDecimals = function(num, st) {
		st = st*1;
		var s = String(st);
		var len= 0;
		if (s.indexOf(".") > -1) {
			len = s.substring(s.indexOf(".")+1, s.length).length;
		}
		return num.toFixed(len);
	};


});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.dhtmlnumber.js